import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Cookies from "js-cookie";
import Logo from "../Logo";

const ForgotPasswordPage = ({ authStatus, setAuthStatus, setCurrentPage, setTitleDescription }) => {
  useEffect(() => {
    setTitleDescription("Fractofolio - Reset Password", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  // const [disabledButton, setDisabledButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const SendPasswordResetRequest = async () => {
    // setDisabledButton(true);
    setLoading(true);

    const queryParameters = new URLSearchParams(window.location.search);
    const passwordResetToken = queryParameters.get("token");
    const email = queryParameters.get("email");

    if(password.length === 0) {
      setError("The Password field is blank.")
      // setDisabledButton(false);
      setLoading(false);
      return "";
    }
    if(confirmPassword.length === 0) {
      setError("The Confirm Password field is blank.")
      // setDisabledButton(false);
      setLoading(false);
      return "";
    }
    if(password !== confirmPassword) {
      setError("The Password and Confirm Password do not match.")
      // setDisabledButton(false);
      setLoading(false);
      return "";
    }

    const data = {
      token: passwordResetToken,
      email: email,
      password: password,
      confirmPassword: confirmPassword
    }

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(apiURL+'/user/password/reset-password', data);
      if(response.data.status === 'ok') {
        setCurrentPage('auth/login')
        setAuthStatus(false);
      } else {
        setError(response.data.text);
      }
    } catch(e) {
      
    }
    
    // setDisabledButton(false);
    setLoading(false);

  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <button onClick={() => setCurrentPage('feed')} className="">
            <Logo textAlign="text-center" />
          </button>
          <h2 className="text-gray-700 text-2xl font-bold mt-5">Forgot Password</h2>
          <p className="text-gray-500 text-sm">Enter your email address below to receive a link to reset your password.</p>
        </div>
        
        <div className="linkedin-card">
          <div className="linkedin-card-content">
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                <input 
                  type="password" 
                  required 
                  className="linkedin-input"
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
                <input 
                  type="password" 
                  required 
                  className="linkedin-input"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              
              <button 
                type="button"
                className="linkedin-btn-primary w-full py-3"
                onClick={() => SendPasswordResetRequest()}
                disabled={loading}
              >
                {loading === false && (
                  <span>Reset Password</span>
                )}
                {loading === true && (
                  <span>Loading...</span>
                )}
              </button>

              {error != "" && (
                <div className="mt-5 max-w-md sm:max-w-lg w-full bg-red-100 rounded-md p-3">
                  <p className="text-sm font-main-medium text-black">{error}</p>
                </div>
              )}
              
            </form>
            
            <div className="mt-6 text-center border-t border-gray-200 pt-6">
              <p className="text-sm text-gray-600">
                Don't have an account?{' '}
                <button 
                  onClick={() => setCurrentPage('auth/signup')}
                  className="text-linkedin-blue hover:underline font-medium"
                >
                  Join now
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;